import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthorizeService, IUser } from '../authorize.service';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard {
  private readonly router = inject(Router);
  private readonly authorize = inject(AuthorizeService);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.authorize.getUser().pipe(
      map((user: IUser | null) => {
        const roleFound = route.data?.roles.some((role: string) =>
          Array.isArray(user?.role) ? user.role.some((userRole: string) => userRole === role) : user?.role === role,
        );
        if (user?.role && !roleFound) {
          this.router.navigate(['error']);
        }

        return true;
      }),
    );
  }
}
